import { useClipboard } from '@chakra-ui/react';
import { Body, Button, HStack, Icon, Tooltip, Link } from '@hover/blueprint';
import { iLink } from '@hover/icons';
import React, { FC } from 'react';
import LinkedinLogo from '../../../assets/svgs/LinkedinHoverBlue';
import FacebookLogo from '../../../assets/svgs/FacebookHoverBlueLogo';
import {
  HOVER_FACEBOOK_LINK,
  HOVER_LINKEDIN_LINK,
  HOVER_TWITTER_LINK,
} from '../../../constants';
import TwitterLogo from '../../../assets/svgs/TwitterHoverBlueLogo';

const BlogPostShareButtons: FC = () => {
  const { hasCopied, onCopy } = useClipboard(
    typeof window !== 'undefined' ? window.location.href : '',
  );

  return (
    <HStack spacing={{ base: 600, tablet: 200 }}>
      <Button
        as={Link}
        href={HOVER_LINKEDIN_LINK}
        color="primary"
        fill="minimal"
        shape="circle"
      >
        <LinkedinLogo width={16} height={16} />
      </Button>
      <Button
        as={Link}
        href={HOVER_FACEBOOK_LINK}
        color="primary"
        fill="minimal"
        shape="circle"
      >
        <FacebookLogo width={16} height={16} />
      </Button>
      <Button
        as={Link}
        href={HOVER_TWITTER_LINK}
        color="primary"
        fill="minimal"
        shape="circle"
      >
        <TwitterLogo width={16} height={16} />
      </Button>
      <Tooltip
        hasArrow={false}
        closeOnClick={false}
        bg="neutral.0"
        placement="top"
        backgroundColor="white"
        fontSize={400}
        px={500}
        py={200}
        shadow="0px 16px 32px rgba(0, 0, 0, 0.18)"
        borderRadius="8px"
        mb={400}
        label={
          <Body display="flex" alignItems="center" size={500}>
            <Icon
              strokeWidth="2px"
              cursor="pointer"
              icon={iLink}
              color={hasCopied ? 'brandNavy.500' : 'primary.600'}
              size="default"
              onClick={onCopy}
            />
            {hasCopied
              ? 'Link copied to clipboard.'
              : 'Copy link to clipboard.'}
          </Body>
        }
      >
        <Button color="primary" fill="minimal" shape="circle" onClick={onCopy}>
          <Icon
            strokeWidth="3px"
            icon={iLink}
            color={hasCopied ? 'brandNavy.500' : 'primary.600'}
            size="small"
          />
        </Button>
      </Tooltip>
    </HStack>
  );
};

export default BlogPostShareButtons;
